import { render, staticRenderFns } from "./BaseMitReservationActivityListSimple.vue?vue&type=template&id=7b60eb8f&scoped=true"
import script from "./BaseMitReservationActivityListSimple.vue?vue&type=script&lang=js"
export * from "./BaseMitReservationActivityListSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60eb8f",
  null
  
)

export default component.exports